<template>
  <div class="kvass-file__custom-drop col middle">
    <span v-html="$t(instance.multiple ? 'dragFilesOrDrop' : 'dragFileOrDrop', { extension: ext })"></span>
    <div v-if="$slots.default" class="mt-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extensions: Array,
  },
  computed: {
    instance() {
      return this.$parent.$parent
    },
    icon() {
      if (this.extensions.length === 1) return ['fal', 'file-' + this.extensions[0]]
      return ['fal', 'file-upload']
    },
    ext() {
      if (!this.extensions.length) return
      return `(${this.extensions.map(e => e.toUpperCase()).join(', ')})`
    },
  },
}
</script>

<style lang="scss">
.kvass-file__custom-drop {
  span {
    font-size: 0.9em;
  }
}
</style>
